<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? $t('add') : $t('update')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      :label-width="$i18n.locale === 'en-US' ? '130px' : '130px'"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户姓名" prop="name">
            <el-input v-model="dataForm.name" placeholder="客户姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item  label="城市" prop="city">
              <el-select  v-model="dataForm.city" filterable clearable placeholder="请选择城市">
                  <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="dataForm.mobile" :disabled="dataForm.id" placeholder="手机号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>  
        <el-col :span="8">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="dataForm.sex" filterable clearable placeholder="请选择">
              <el-option
                v-for="item in sexList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年齢" prop="age">
            <el-input v-model="dataForm.age" placeholder="年齢"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="交易ID" prop="transId">
            <el-input
              v-model="dataForm.transId"
              placeholder="交易ID"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="所属app" prop="appId">
            <el-select v-model="dataForm.appId" filterable clearable placeholder="请选择">
              <el-option
                v-for="item in appIdList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
         <el-col :span="8">
          <el-form-item label="数据来源" prop="ip">
            <el-input v-model="dataForm.ip" placeholder="数据来源"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="备注" prop="remark">
            <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  data() {
    return {
      visible: false,
      operationList: [],
      companys: [],
      channels: [],
      pages: [],
      shebaoList:[],
      houseList:[],
      zmScoreList:[],
      isPushs: [
        {
          label: "未推送",
          value: 0,
        },
        {
          label: "已推送",
          value: 1,
        },
      ],
       appIdList: [
        {
          label: "A面用户",
          value: "A面用户",
        },
        {
          label: "B面用户",
          value: "B面用户",
        },
      ],
      sexList: [
        {
          label: "男",
          value: "男",
        },
        {
          label: "女",
          value: "女",
        },
      ],
      statusList: [
        {
          label: "有效",
          value: 1,
        },
        {
          label: "无效",
          value: 0,
        },
      ],
      marrieds: [
        {
          label: "未婚",
          value: 1,
        },
        {
          label: "已婚",
          value: 2,
        },
      ],
      citys:[],
      dataForm: {
        mobileLeaseQuantity: '',
        id: "",
        name: "",
        sex: "",
        mobile: "",
        telLocation: "",
        age: "",
        cardNo: "",
        operationId: "",
        channelId: "",
        companyId: "",
        pageId: "",
        ip: "",
        leadsArea: "",
        city: "",
        url: "",
        isPush: "",
        pushMsg: "",
        pushDate: "",
        pushStatus: "",
        returnMsg: "",
        address: "",
        bundle: "",
        isMarried: "",
        education: "",
        professional: "",
        employmentTime: "",
        monthlyIncome: "",
        payrollType: "",
        money: "",
        useFor: "",
        loanLongTime: "",
        creditSituation: "",
        isCredit: "",
        shebao: "",
        gongjijin: "",
        car: "",
        carType: "",
        carModel: "",
        carLife: "",
        baodanIs: "",
        zmScore: "",
        weili: "",
        businessLicense: "",
        house: "",
        houseType: "",
        houseSize: "",
        houseLife: "",
        shopName: "",
        shopAddress: "",
        leadsEmail: "",
        leadsQq: "",
        leadsWechat: "",
        status: "",
        remark: "",
        accountId: "",
        accountName: "",
        adgroupId: "",
        adgroupName: "",
        adsId: "",
        adsName: "",
        creativeId: "",
        creativeName: "",
        createBy: "",
        createTime: "",
        updateBy: "",
        updateTime: "",
        deleteTime: "",
        transId: "",
        appId:"",
      },
    };
  },
  computed: {
    dataRule() {
      return {
        name: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        money:[
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        operationId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        channelId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        appId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        pageId: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        leadsEmail: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          // {
          //   pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
          //   message: "请输入正确的手机号码或者座机号",
          // },
        ],
        // mobile: [
        //   { required: true, message: "请输入手机号", trigger: "blur" },
        //   {
        //     pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
        //     message: "请输入正确的手机号码",
        //   },
        // ],
        cardNo: [
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号码",
          },
        ],
      };
    },
  },
  methods: {
    async getCityOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.citys=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.citys.push({label:element.dictLabel,value:element.dictValue})
                  })
                  /*let citys = {}
                  for(let i = 0; i< res.data.length; i++){
                      citys[i].value=res.data[i].dictValue
                      citys[i].label=res.data[i].dictLabel
                  }*/
              }
          }).catch(() => {})
      },
    init() {
      this.getOperatorsOptions();
      this.getCompanysOptions();
      this.getchannelsOptions();
      this.getPageOptions();
      this.getCityOptions();
      this.getZmScore();
      this.getShebao();
      this.getHouse();
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          this.getInfo();
        }
      });
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/sys/appcustomers/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
        })
        .catch(() => {});
    },
    //初始化芝麻分下拉框的选项
    async getZmScore() {
     this.$http.get(`/sys/dict/data/list?dataType=zmScore`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.zmScoreList=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.zmScoreList.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
    },
    //初始化社保下拉框的选项
    async getShebao() {
     this.$http.get(`/sys/dict/data/list?dataType=shebao`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.shebaoList=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.shebaoList.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
    },
    //初始化房产下拉框的选项
    async getHouse() {
     this.$http.get(`/sys/dict/data/list?dataType=house`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.houseList=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.houseList.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
    },
    //初始化运营机构下拉框的选项
    async getOperatorsOptions() {
      this.$http
        .get(`/sys/operations/listAll`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.operationList = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.operationList.push({
                label: element.name,
                value: element.id,
              });
            });
          }
        })
        .catch(() => {});
    },
    //初始化渠道下拉框中的选项
    async getchannelsOptions() {
      this.$http
        .get(`/sys/channels/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.channels = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.channels.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http
        .get(`/sys/companies/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.companys = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.companys.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
    //初始化落地页下拉框中的选项
    async getPageOptions() {
      this.$http
        .get(`/sys/landingpages/list`)
        .then(({ data: res }) => {
         
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.pages = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.pages.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.$unblank(this.dataForm)
          
          this.$http[!this.dataForm.id ? "post" : "put"](
            "/sys/appcustomers/",
            this.dataForm
          )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
